import Magnifier from '../../../assets/magnifier.svg';

const MagnifierIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Magnifier {...props} />;
};

export default MagnifierIcon;
